export interface IFindDonorResult {
    id: number,
    firstName: string,
    lastName: string,
    email: string,
    birthDate: string,
    registrationDate: string
}